import { get } from 'lodash'
import flatten from 'lodash/flatten'
import { ISelectOptGroup } from 'transfix-ui/components/Select'
import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { getStateArray } from './getStateArray'

const COUNTRIES_BY_CODE = {
  US: 'United States',
  CA: 'Canada',
}

/**
 * @example getStateOptions(['US']) // { label: 'US', options: [...] }}
 * @example getStateOptions(['US'], false) // [{ label: 'Alabama', abbr: 'AL', ...etc }] }}
 */
export const getStateOptions = (
  includeCounties: string[],
  { hideGroupLabel = false }: { hideGroupLabel?: boolean } = {}
): TSelectOpt[] | ISelectOptGroup[] => {
  const stateGroups = getStateArray(includeCounties)

  if (hideGroupLabel) {
    const stateArrays = stateGroups.map(([, states]) => {
      return states.map(({ abbr: value, name: label }) => ({
        value,
        label,
      }))
    })

    return flatten(stateArrays)
  }

  return stateGroups.map(([countryKey, states]) => {
    return {
      label: get(COUNTRIES_BY_CODE, countryKey),
      options: states.map(({ abbr: value, name: label }) => ({
        label,
        value,
      })),
    }
  })
}
